module.exports = __webpack_public_path__ + "static/media/AG.198eb2e8.svg";